const SigmaSquadObj = () => {
    return (
        <div className='SSObj'>
            <h2>Objectives</h2>
            <div className="sep1"></div>
            <div className="objs">
                <ul>
                    <li>
                        Creating a culture of AI and Deep Learning Technologies among the students of IIT Tirupati.
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default SigmaSquadObj